import { RouterProvider } from '@tanstack/react-router'
import LogRocket from 'logrocket'
import { createRoot } from 'react-dom/client'

import { envVariables } from './lib/env'
import { createAppRouter } from './router'

if (envVariables.NODE_ENV !== 'development') {
  // GraphQL の変数・レスポンスや Authorization をセッション記録サービスへ送らないため、通信記録を無効化する。
  LogRocket.init('czedne/mbfab-manager', { network: { isEnabled: false } })
}

// タブを開いたまま古い JavaScript が使われ続けるのを防ぐため、旧 client と同じ間隔で更新する
setTimeout(
  () => {
    location.reload()
  },
  6 * 60 * 60 * 1000,
)

const container = document.getElementById('root')
if (container === null) {
  throw new Error('#root element not found')
}
createRoot(container).render(<RouterProvider router={createAppRouter()} />)
